import { type VariantProps, cva } from 'class-variance-authority'

export { default as Avatar } from './Avatar.vue'
export { default as AvatarImage } from './AvatarImage.vue'
export { default as AvatarFallback } from './AvatarFallback.vue'

export const avatarVariant = cva(
  'inline-flex items-center justify-center font-normal text-foreground select-none shrink-0 overflow-hidden',
  {
    variants: {
      size: {
        icon: 'h-6 w-6',
        'icon-larger': 'h-9 w-9 max-h-full max-w-full',
        sm: 'h-10 w-10 text-xs bg-white',
        base: 'h-16 w-16 text-2xl',
        md: 'h-24 w-24 text-3xl',
        lg: 'h-32 w-32 text-5xl',
      },
      shape: {
        circle: 'rounded-full',
        square: 'rounded-md',
        frame: 'rounded-lg',
      },
    },
  },
)

export type AvatarVariants = VariantProps<typeof avatarVariant>
